(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection-list"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const feeds = document.querySelectorAll('.collection-list-feed[id^="CollectionListFeed-"]');
    if (!feeds.length) return;

    feeds.forEach((feed) => {
      const sectionId = feed.id.replace('CollectionListFeed-', '');
      let nextLink = document.querySelector(`#CollectionListNext-${sectionId}`);
      if (!nextLink) return;

      let isLoading = false;
      const feedSelector = `#CollectionListFeed-${sectionId}`;

      const observer = new IntersectionObserver(
        async (entries) => {
          const hit = entries.some((entry) => entry.isIntersecting);
          if (!hit || isLoading || !nextLink) return;

          isLoading = true;
          try {
            const nextUrl = new URL(nextLink.href, window.location.origin);
            nextUrl.searchParams.set('section_id', sectionId);

            const response = await fetch(nextUrl.toString(), {
              headers: { 'X-Requested-With': 'XMLHttpRequest' },
            });

            if (!response.ok) {
              throw new Error(`Failed to load collections: ${response.status}`);
            }

            const html = await response.text();
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');
            const newFeed = doc.querySelector(feedSelector);
            const newNextLink = doc.querySelector(`#CollectionListNext-${sectionId}`);

            if (newFeed) {
              feed.insertAdjacentHTML('beforeend', newFeed.innerHTML);
            }

            if (newNextLink) {
              nextLink.href = newNextLink.href;
            } else {
              observer.disconnect();
              nextLink.remove();
              nextLink = null;
            }
          } catch (error) {
            console.error('[CollectionList] Infinite loading failed', error);
          } finally {
            isLoading = false;
          }
        },
        { rootMargin: '800px 0px' }
      );

      observer.observe(nextLink);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
